<template>
  <div
    class="avatar"
    ref="avatar"
  >
    <a-dropdown
      :trigger="['click', 'hover']"
      overlayClassName="dropdown"
    >
      <a
        class="ant-dropdown-link"
        @click.prevent
      >
        <a-avatar
          class="headimg-s"
          src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
        />
        <span class="name">{{currentUser.userName}}</span>
      </a>
      <template #overlay>
        <a-menu>
          <a-menu-item @click="showModalMsg">
            <img
              class="drop-icon"
              src="@/assets/images/icon-grxx@2x.png"
            >
            <span class="drop-span">个人信息</span>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item @click="showModalPwd">
            <img
              class="drop-icon"
              src="@/assets/images/icon-xgmm@2x.png"
            >
            <span class="drop-span">修改密码</span>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item @click="showModalQuiet">
            <img
              class="drop-icon"
              src="@/assets/images/icon-tcdl@2x.png"
            >
            <span class="drop-span">退出登录</span>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <!-- 个人信息弹窗 -->
    <a-modal
      class="modal msg"
      title="个人信息"
      width="550px"
      :centered="true"
      v-model:visible="msgVisible"
      :getContainer="()=>$refs.avatar"
      :footer="null"
    >
      <a-row>
        <a-col :span="6">
          <img
            class="headimg"
            src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
          >
          <!-- <a-button
            class="edit"
            @click="editMsg"
          >
            <img src="@/assets/images/menus/icon-bj@2x.png">
            编辑资料
          </a-button> -->
        </a-col>
        <a-col :span="18">
          <div class="info">
            <img src="@/assets/images/menus/icon-1@2x.png">
            <p>用户名：</p>
            <span>{{currentUser.userName}}</span>
          </div>
          <div class="info">
            <img src="@/assets/images/menus/icon-2@2x.png">
            <p>角色：</p>
            <span>{{currentUser.roleName}}</span>
          </div>
          <div class="info">
            <img src="@/assets/images/menus/icon-3@2x.png">
            <p>部门：</p>
            <span>{{currentUser.deptName}}</span>
          </div>
          <!-- <div class="info">
            <img src="@/assets/images/menus/icon-4@2x.png">
            <p>性别：</p>
            <span>Matthew</span>
          </div> -->
          <div class="info">
            <img src="@/assets/images/menus/icon-5@2x.png">
            <p>电话：</p>
            <span>{{currentUser.mobile}}</span>
          </div>
          <div class="info">
            <img src="@/assets/images/menus/icon-6@2x.png">
            <p>邮箱：</p>
            <span>{{currentUser.email}}</span>
          </div>
          <div class="info">
            <img src="@/assets/images/menus/icon-7@2x.png">
            <p>简介：</p>
            <span>{{currentUser.description}}</span>
          </div>
          <!-- <div class="info">
            <img src="@/assets/images/menus/icon-8@2x.png">
            <p>IP：</p>
            <span>Matthew</span>
          </div>
          <div class="info">
            <img src="@/assets/images/menus/icon-9@2x.png">
            <p>登录地点：</p>
            <span>Matthew</span>
          </div>
          <div class="info">
            <img src="@/assets/images/menus/icon-10@2x.png">
            <p>浏览器：</p>
            <span>Matthew</span>
          </div>
          <div class="info">
            <img src="@/assets/images/menus/icon-11@2x.png">
            <p>登录系统：</p>
            <span>Matthew</span>
          </div> -->
        </a-col>
      </a-row>
    </a-modal>
    <!-- 编辑资料弹窗 -->
    <div
      ref=editmsg
      class="editmsg"
    >
      <a-modal
        class="modal msg"
        title="编辑资料"
        width="550px"
        :centered="true"
        v-model:visible="editMsgVisible"
        :getContainer="()=>$refs.editmsg"
        @ok="handleOkMsg"
        cancelText="取消"
        okText="确定"
      >
        <a-row>
          <a-col>
            <a-upload
              v-model:file-list="fileList"
              name="file"
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              @change="handleChange"
            >
              <img
                class="headimg"
                src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
              >
              <span>点击图片更换头像</span>
            </a-upload>

          </a-col>
        </a-row>

        <a-form
          :model="formUser"
          @finish="handleFinishPwd"
        >
          <a-row>
            <a-col :span="11">
              <a-form-item>
                <p>用户名</p>
                <a-input
                  class="ipt"
                  v-model:value="formUser.userName"
                  placeholder="请输入用户名"
                >
                </a-input>
              </a-form-item>
              <a-form-item>
                <p>邮箱</p>
                <a-input
                  class="ipt"
                  v-model:value="formUser.email"
                  placeholder="请输入邮箱"
                >
                </a-input>
              </a-form-item>
              <a-form-item>
                <p>电话</p>
                <a-input
                  class="ipt"
                  v-model:value="formUser.mobile"
                  placeholder="请输入电话"
                >
                </a-input>
              </a-form-item>
              <a-form-item>
                <p>部门</p>
                <a-input
                  class="ipt"
                  v-model:value="formUser.deptName"
                  placeholder="请输入部门"
                >
                </a-input>
              </a-form-item>
            </a-col>
            <a-col
              :span="11"
              offset="2"
            >
              <!-- <a-form-item>
                <p>性别</p>
                <a-input
                  class="ipt"
                  v-model:value="formState.old_pwd"
                  placeholder="请输入性别"
                >
                </a-input>
              </a-form-item> -->
              <a-form-item>
                <p>简介</p>
                <a-textarea
                  v-model:value="formUser.description"
                  :maxlength="100"
                  placeholder="请输入简介"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
    </div>
    <!-- 修改密码弹窗 -->
    <a-modal
      class="modal alter-pwd"
      title="修改密码"
      width="320px"
      :centered="true"
      v-model:visible="pwdVisible"
      :getContainer="()=>$refs.avatar"
      :footer="null"
    >
      <a-form
        :model="formState"
        @finish="handleFinishPwd"
      >
        <a-form-item>
          <p>旧密码</p>
          <a-input
            class="ipt"
            type="password"
            v-model:value="formState.old_pwd"
            :visibilityToggle="true"
            placeholder="请输入旧密码"
            @blur="checkPwd"
          >
          </a-input>
        </a-form-item>
        <a-form-item>
          <p>新密码</p>
          <a-input
            class="ipt"
            type="password"
            v-model:value="formState.new_pwd"
            :visibilityToggle="true"
            placeholder="请输入新密码"
          >
          </a-input>
        </a-form-item>
        <a-form-item>
          <p>确认密码</p>
          <a-input
            class="ipt"
            type="password"
            v-model:value="formState.new_pwd2"
            :visibilityToggle="true"
            placeholder="请再次输入新密码"
          >
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            block
            class="btn"
            type="primary"
            html-type="submit"
            :disabled="formState.old_pwd === '' || formState.password === '' || formState.new_pwd2 === ''"
          >
            确定
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 退出登录弹窗 -->
    <a-modal
      v-model:visible="quietVisible"
      :centered="true"
      title="退出"
      ok-text="确认"
      cancel-text="取消"
      @ok="hideModalQuiet"
    >
      <p>确定退出登录？</p>
    </a-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import router from "@/router/index.js";
import { updateUser, checkPassword, updatePassword } from "@/api/login/login.js";
export default {
  name: "avatar",
  data() {
    return {
      currentUser: {},
      hover: false,
      msgVisible: false, //个人信息modal
      editMsgVisible: false, //编辑信息modal
      fileList: '',
      pwdVisible: false, //修改密码modal
      formState: {
        old_pwd: '',
        new_pwd: '',
        new_pwd2: '',
      },
      formUser: {},
      quietVisible: false, //退出登录modal
    }
  },
  mounted() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    this.formUser = JSON.parse(localStorage.getItem('currentUser'))
    console.log('currentUser', this.currentUser)
  },
  methods: {
    showModalMsg() {
      console.log(2)
      this.msgVisible = true
    },
    editMsg() {
      this.msgVisible = false
      this.editMsgVisible = true
    },
    handleOkMsg() {
      console.log('当前资料', this.formUser)
      updateUser(this.formUser).then(res => {
        if (res.code === 200) {
          this.editMsgVisible = false
        }
      })
      // this.editMsgVisible = false
    },
    handleOk() {
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000);
    },
    showModalPwd() {
      this.pwdVisible = true
    },
    checkPwd() { //检查旧密码
      const tempData = {
        password: this.formState.old_pwd
      }
      checkPassword(tempData).then(res => {
        if (!res.data) {
          this.$message.error('原密码错误');
        }
      })
    },
    handleFinishPwd() {
      if (this.formState.new_pwd == this.formState.new_pwd2) {
        const tempData = {
          password: this.formState.new_pwd
        }
        updatePassword(tempData).then(res => {
          if (res.code === 200) {
            this.pwdVisible = false
            this.$message.success(res.data);
          }
        })
      } else {
        this.$message.error('两次输入的密码不一样');
      }
    },
    showModalQuiet() {
      this.quietVisible = true
    },
    hideModalQuiet() {
      localStorage.clear()
      this.quietVisible = false
      router.push({ path: '/login/login' })
    },
  }
};
</script>
<style scoped>
.dropdown {
  border-radius: 10px;
}
.ant-dropdown-link :deep() .name {
  vertical-align: middle;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
}
.drop-span {
  display: inline-block;
  margin-right: 20px;
  font-size: 12px;
  color: #222;
  font-family: PingFangSC-Regular;
}
.drop-icon {
  display: inline-block;
  width: 12px;
  margin: 3px 10px 3px 0;
  vertical-align: text-top;
}
.avatar :deep() .ant-modal-header,
.avatar :deep() .ant-modal-footer {
  border: 0;
}
.headimg {
  width: 100px;
  margin-bottom: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.edit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100px;
  height: 30px;
  color: #0088ff;
  font-size: 12px;
  border-color: #0088ff;
  border-radius: 5px;
}
.edit img {
  width: 15px;
}
.info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 12px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #222;
}
.info img {
  width: 17px;
}
.info p {
  width: 80px;
  margin-left: 15px;
}
.info span {
  font-size: 14px;
}
.avatar :deep() .ant-modal-content {
  border-radius: 12px;
}
.avatar :deep() .ant-modal-header {
  border-radius: 12px;
}
.avatar :deep() .ant-modal-title {
  padding-left: 10px;
  margin-top: 20px;
  vertical-align: top;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #222222;
  border-left: 5px solid #0088ff;
}
.ant-upload .headimg {
  width: 58px;
}
.ant-upload .headimg + span {
  margin-left: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #888888;
}
.editmsg :deep() textarea {
  height: 205px;
}
.editmsg :deep() .ant-btn:nth-child(1) {
  width: 110px;
  height: 40px;
  color: #0088ff;
  border: 1px solid #0088ff;
  border-radius: 6px;
}
.editmsg :deep() .ant-btn-primary {
  width: 110px;
  height: 40px;
  margin-bottom: 24px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.ant-form-item-control-input-content p {
  font-size: 12px;
  line-height: 1.6;
  font-weight: 600;
  color: #222222;
  font-family: PingFang SC;
}
.ant-form-item-control-input-content input {
  height: 40px;
  border-radius: 6px;
}
</style>
